export default import.meta.ROLLDOWN_FILE_URL_nx4KNwLu1yFUuwJzZBrYHw